/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Lottie from 'react-lottie';
import { format, subDays, addDays } from 'date-fns';

import { ContainerStudies, ContainerLoading } from './style.js';
import Loading from '../../../assets/loading.json';
import Menu from '../../../components/Menu/index.js';
import Footer from '../../../components/Footer/index.js';
import AuthGuard from '../../../components/AuthGuard/index.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';

import api from '../../../services/api.js';

import ButtonDefault from '../../../components/ButtonDefault/index.js';
import InputDefault from '../../../components/InputDefault/index.js';
import ButtonAction from '../../../components/ButtonAction/index.js';
import ModalDelete from '../../../components/Modals/ModalDelete/index.js';
import { Link } from 'react-router-dom';

const FlagEconmomyList = () => {
  document.title = 'Enermerco - Economia de Bandeira';

  const [isLoading, setIsLoading] = useState(true);

  const [idDm016, setIdDm016] = useState('');
  const [flagEconomyList, setFlagEconomyList] = useState('');

  const [modalDelete, setModalDelete] = useState(false);
  const [modalDeleteId, setModalDeleteId] = useState(false);

  const loadingAnimation = {
    loop: true,
    autoplay: true,
    animationData: Loading
  };

  const applyFilter = (idDm010, dateFrom, dateTo) => {
    let url = 'flag_economy?';
    if (idDm016 !== '') {
      url += `&id=${idDm016}`;
    }
    api
      .get(url)
      .then((response) => {
        setFlagEconomyList(response.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const searchFilter = useCallback(() => {
    applyFilter(idDm016);
  }, [idDm016]);

  const cleanFields = useCallback(() => {
    setIdDm016('');
    applyFilter('');
  }, [idDm016]);

  const deleteFlagEconomy = useCallback(
    (id) => {
      api
        .delete(`flag_economy?id=${id}`)
        .then((response) => {
          setModalDelete(false);
          if (response.status === 200) {
            toast.success('Economia de Bandeira removida com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          cleanFields();
          setModalDelete(false);
          toast.success(error);
        });
    },
    [modalDelete]
  );

  useEffect(() => {
    applyFilter(idDm016);
  }, []);

  return (
    <>
      <AuthGuard />
      <Menu />
      {isLoading ? (
        <ContainerLoading>
          <Lottie options={loadingAnimation} style={{ width: '100%', height: 400 }} />
          <h1>Carregando Economia de Bandeiras...</h1>
        </ContainerLoading>
      ) : (
        <Container>
          <ContainerStudies>
            <h2>Economia de Bandeiras</h2>
            <Link to="./../add">
              <ButtonDefault Width={'150px'} Margin={'0px 30px 30px 0px'} Text="Adicionar" />
            </Link>
            <h3>Filtros</h3>
            <Row>
              <Col xs={2}>
                <InputDefault
                  placeholder="Código"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Código'}
                  value={`${idDm016}`}
                  onChange={(e) => setIdDm016(e.target.value)}
                />
              </Col>
            </Row>
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Buscar"
              onClick={searchFilter}
            />
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Limpar"
              onClick={() => {
                cleanFields();
              }}
            />
            <Table striped bordered hover variant="light">
              <thead>
                <tr>
                  <th style={{ width: '5%', textAlign: 'right' }}>Código</th>
                  <th style={{ width: '5%' }}>Bandeira</th>
                  <th style={{ width: '20%' }}>Distribuidora</th>
                  <th style={{ width: '10%', textAlign: 'right' }}>% Desconto</th>
                  <th style={{ width: '5%', textAlign: 'center' }}>Ação</th>
                </tr>
              </thead>
              <tbody>
                {flagEconomyList.map((flagEconomy) => (
                  <tr>
                    <td style={{ textAlign: 'right' }}>{flagEconomy.ID_DM016}</td>
                    <td>{`${flagEconomy.NM_BANDEIRA} (${flagEconomy.ID_DM004})`}</td>
                    <td>{`${flagEconomy.NM_DISTRIBUIDORA} (${flagEconomy.ID_DM003})`}</td>
                    <td style={{ textAlign: 'right' }}>
                      {Number(flagEconomy.PR_DESCONTO).toFixed(2).replace('.', ',')}
                    </td>
                    <td
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '45px',
                        justifyContent: 'center'
                      }}>
                      <Link to={`./../edit/${flagEconomy.ID_DM016}`}>
                        <ButtonAction Action="Edit" />
                      </Link>
                      <ButtonAction
                        Action="Remove"
                        onClick={() => {
                          setModalDeleteId(flagEconomy.ID_DM016);
                          setModalDelete(true);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ContainerStudies>
          <ToastContainer />
          <ModalDelete
            modalOpen={modalDelete}
            handleClose={() => setModalDelete(false)}
            handleConfirm={() => deleteFlagEconomy(modalDeleteId)}
            handleCancel={() => setModalDelete(false)}
            modalTitleText={`Deseja excluir o Histórico #${modalDeleteId}?`}
            id={idDm016}
          />
          <Footer />
        </Container>
      )}
    </>
  );
};

export default FlagEconmomyList;
